export default __webpack_public_path__ + "static/backgroundGallery-0aeb7eae9542aa0f30b86b442903d569.jpg";